export default __webpack_public_path__ + "static/strategy-8b74022dc45aa4a85c10ad082b707141.png";